"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _BarChart = _interopRequireDefault(require("@rsuite/icon-font/lib/charts/BarChart"));

// Generated by script, don't edit it please.
var BarChart = (0, _createSvgIcon["default"])({
  as: _BarChart["default"],
  ariaLabel: 'bar chart',
  category: 'charts',
  displayName: 'BarChart'
});
var _default = BarChart;
exports["default"] = _default;
module.exports = exports.default;